// Shared by route-driven store reads, the search input and the API boundary.
// Validation never truncates the user's query or replaces it with an unfiltered request.
export const messageQueryIssue = (value) => {
  const length = Array.from(String(value ?? '').trim()).length;
  if (length > 0 && length < 2) return 'short';
  if (length > 200) return 'long';
  return null;
};
